'use strict';

angular.module('app.print.header', []);